export default class LoadMore {
  loadMoreAttr = 'data-load-more';
  postListAttr = 'data-post-list';
  itemAttr = 'data-post-item';
  placeholderAttr = 'data-placeholder-cards';

  constructor() {
    if (!this.loadMoreButton) return;
    this.registerEvents();
  }

  // Private methods
  registerEvents() {
    this.loadMoreButton.addEventListener('click', () => {
      this.loadMore();
    });
  }

  loadMore() {
    try {
      const nextUrl = this.loadMoreButton.getAttribute('data-next');
      if (!nextUrl) return;
      this.setState(true);
      fetch(nextUrl, {
        method: 'GET',
      })
        .then((response) => response.text())
        .then((html) => {
          if (!html) return;
          if (!this.postsContainer) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const items = this.getItems(doc);
          items.forEach((post) => {
            this.postsContainer.appendChild(post);
          });
          this.movePlaceholdersToEnd();
          const next = this.getLoadMoreButton(doc);
          const nextValue = next?.getAttribute('data-next');
          if (nextValue)
            this.loadMoreButton.setAttribute('data-next', nextValue);
          if (!next) this.loadMoreButton.remove();
          this.setState(false);
        });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err?.message);
      this.setState(false);
    }
  }

  movePlaceholdersToEnd() {
    const placeholders = this.postsContainer.querySelectorAll(`[${this.placeholderAttr}]`);
    placeholders.forEach(placeholder => {
      this.postsContainer.appendChild(placeholder);
    });
  }

  /**
   *
   * @param {Document} document
   * @returns {NodeListOf<Element>}
   */
  getItems(document) {
    return document.querySelectorAll(`[${this.itemAttr}]`);
  }

  /**
   *
   * @param {Document} document
   * @returns {HTMLButtonElement}
   */
  getLoadMoreButton(document) {
    return document.querySelector(`[${this.loadMoreAttr}]`);
  }

  /**
   *
   * @param {boolean} loading
   */
  setState(loading) {
    if (loading) {
      this.loadMoreButton?.setAttribute('disabled', 'disabled');
      this.loadMoreButton?.classList.add('loading');
    } else {
      this.loadMoreButton?.removeAttribute('disabled');
      this.loadMoreButton?.classList.remove('loading');
    }
  }

  // Getters
  get loadMoreButton() {
    return this.getLoadMoreButton(document);
  }

  /**
   *
   * @returns {HTMLDivElement}
   */
  get postsContainer() {
    return document.querySelector(`[${this.postListAttr}]`);
  }
}